import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';


function ExpenseHeadIndex() {
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    let companyid = companyId;
    if (isSuperAdmin == true && companyId == superCompanyId) {
        companyid = 0;
    }


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('ExpenseHeadApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Head Details:', error);
            });
    }, []);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            {/* <div className='w-full mb-2 flex'>
                <h5 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>Account Head</h5>

                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
                <Tooltip title="Create Account Head">
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                            marginRight: '8px',
                            background: 'linear-gradient(to right, darkslategray, slategray)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',

                        }}
                        component={Link}
                        to="/ExpenseHeadCreate"
                    >
                        Create
                    </Button>
                </Tooltip>
            </div> */}
            <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
                <h5 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                    Account Head
                </h5>

                <div className='flex items-center mt-2 md:mt-0 md:ml-4'>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '150px' }}
                        />
                    )}
                </div>

                <Tooltip title="Create Account Head">
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                            marginTop: '10px',
                            marginLeft: '8px',
                            background: 'linear-gradient(to right, darkslategray, slategray)',
                            borderRadius: '50px',
                            padding: '10px 20px',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                        }}
                        component={Link}
                        to="/ExpenseHeadCreate"
                    >
                        Create
                    </Button>
                </Tooltip>
            </div>


            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'teal' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'white', fontSize: '16px', fontWeight: 'bolder', padding: '7px' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'white', fontSize: '16px', fontWeight: 'bolder', padding: '7px' }}>Account Head Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'white', fontSize: '16px', fontWeight: 'bolder', padding: '7px' }}>Remarks </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'white', fontSize: '16px', fontWeight: 'bolder', padding: '7px' }}>Income/Expense</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', color: 'white', fontSize: '16px', fontWeight: 'bolder', padding: '7px' }}>ACTIONS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'white' }}>

                            {data.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', height: '10px', fontSize: '14px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', height: '10px', fontSize: '14px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', height: '10px', fontSize: '14px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.Remarks}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #ddd', height: '10px', fontSize: '14px', padding: '1px', textAlign: 'left', fontWeight: 'bolder' }}>{item.ExpenseOrIncome}</TableCell>
                                    <TableCell sx={{ height: '10px' }}>
                                        <Link to={`/ExpenseHeadEdit/${item.ID}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'red', height: '20px' }} />
                                            </IconButton>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default ExpenseHeadIndex;

